var React = require('react');

function ShoppingCart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.25 17.25H6.545L3.93 2.866a.75.75 0 0 0-.738-.616H1.5M7.5 21a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75ZM17.25 21a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z","stroke":"currentColor","strokeWidth":"2.002","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.864 13.5h11.77a1.5 1.5 0 0 0 1.476-1.232L20.25 6H4.5","stroke":"currentColor","strokeWidth":"2.002","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ShoppingCart.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ShoppingCart;

ShoppingCart.default = ShoppingCart;
